import {
    apiRequest,
    pangkatP3KCreate
} from "../../../../../services/adapters/master/pangkatP3KService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", pangkatP3KCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository